export enum SummaryCardType {
  progress = 'cases in progress',
  outstanding = 'requirements outstanding',
  completed = 'cases completed'
}

export enum CaseFieldsEnum {
  created = 'created',
  instructionNumber = 'instructionNumber',
  clientName = 'clientName',
  clientId = 'clientId',
  instructionCategory = 'instructionCategory',
  instructionType = 'instructionType',
  proposalNumber = 'proposalNumber',
  investmentNumber = 'investmentNumber',
  stageAndStatus = 'stageAndStatus',
  lastModified = 'lastModified',
  id = 'id'
}

export enum PolicyMaintenanceInstruction {
  cessionsLiens = 'Cessions/Liens',
  incomeChanges = 'Income Changes',
  regularWithdrawalChanges = 'Regular Withdrawal Changes',
  recurringPremium = 'Recurring Premium',
  intermediaryChanges = 'Intermediary Changes',
  it88Deductions = 'IT88 Deductions',
  phasingIn = 'Phasing-in',
  other = 'Other (Specify if Other)',
  feesAndCharges = 'Fees and Charges',
  recognitionOfTransfer = 'Recognition of Transfer',
  deductionsCourtOrders = 'Deductions (Court Orders)',
  policyRoles = 'Policy Roles'
}

export enum ClientMaintenanceInstruction {
  bankDetailsChange = 'Bank details change',
  clientDetails = 'Client Details',
  enquiries = 'Enquiries',
  fica = 'FICA',
  par2_2B = 'Par 2(2B)',
  secureServiceITLRequest = 'Secure Service ITL Request',
  secureServicesAR = 'Secure Services AR',
  secureServicesDeregister = 'Secure Services De-register',
  secureServicesRegister = 'Secure Services Register',
  taxMaintenance = 'Tax Maintenance',
  unknownAddress = 'Unknown Address'
}

export enum NewBusinessInstruction {
  tfsaAdhoc = 'TFSA Adhoc',
  tfsaUnitTransfer = 'TFSA Unit Transfer',
  tfsaUnitTransferAdhoc = 'TFSA Unit Transfer Adhoc',
  endowment = 'Endowment',
  endowmentAdhoc = 'Endowment Adhoc',
  endowmentContinuation = 'Endowment Continuation',
  sinkingFund = 'Sinking Fund',
  raUnitTransferAdhoc = 'RA Unit Transfer Adhoc',
  preservationPensionFund = 'Preservation Pension Fund',
  preservationPensionFundAdhoc = 'Preservation Pension Fund Adhoc',
  preservationProvidentFund = 'Preservation Provident Fund',
  preservationProvidentFundAdhoc = 'Preservation Provident Fund Adhoc',
  preservationPensionFundUnitTransfer = 'Preservation Pension Fund Unit Transfer',
  preservationProvidentFundUnitTransfer = 'Preservation Provident Fund Unit Transfer',
  illa = 'ILLA'
}

export type InstructionType =
  | PolicyMaintenanceInstruction
  | ClientMaintenanceInstruction
  | NewBusinessInstruction;

export enum Stage {
  Stage1 = 'Instruction received',
  Stage2 = 'Requirements validation',
  Stage3 = 'Processing in progress',
  Stage4 = 'Completed',
  Cancelled = 'Cancelled'
}
